import {Box, Card, CardContent, CardHeader} from "@mui/material";
import commercials from "../../assets/contacts/distribucion-comercial.png"

const ContactsPage = () => {
    return (
        <Card>
            <CardHeader title={'Distribución Comercial'} />
            <CardContent>
                <Box sx={{ width: '58%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto' }} 
                     component={'img'}
                     src={commercials}
                     alt={"Distribución comercial 2025"}
                />
            </CardContent>
        </Card>
    )
}


export default ContactsPage